export default "__VITE_PUBLIC_ASSET__0c59f084__"